/**
 * El «Detalle técnico» plegado: lo que mira el equipo de Deenex (tiempos por tramo, códigos de error, lo que
 * informa o factura Twilio), separado de lo que mira el comercio. Cerrado salvo que la última vez se haya dejado
 * abierto. Si se pasa `conFalla`, el título avisa que falló la última actualización, para que no quede escondido.
 *
 * Vivía adentro de Estadísticas. El detalle de una campaña tenía «Tiempos de entrega» y «Costo según Twilio» al
 * mismo nivel que los resultados, sin plegar: el comercio leía «Twilio» en la pantalla de su campaña. Ahora los dos
 * usan éste.
 *
 * Abierto o cerrado se recuerda por navegador, uno solo para las dos pantallas: es una comodidad («quiero ver lo
 * técnico»), no un dato.
 */

import { useState } from "react";
import type { ReactNode } from "react";
import { ChevronRight, Wrench } from "lucide-react";

const CLAVE_TECNICO = "deenex-activa:estadisticas-tecnico-abierto";
function leerTecnicoAbierto(): boolean {
  try { return localStorage.getItem(CLAVE_TECNICO) === "1"; } catch { return false; }
}
function guardarTecnicoAbierto(abierto: boolean): void {
  try { localStorage.setItem(CLAVE_TECNICO, abierto ? "1" : "0"); } catch { /* sin storage: se abre cerrado */ }
}

export function DetalleTecnico({ subtitulo, conFalla = false, children }: { subtitulo: string; conFalla?: boolean; children: ReactNode }) {
  const [abierto, setAbierto] = useState(leerTecnicoAbierto);
  return (
    <details open={abierto} onToggle={(e) => { const a = (e.currentTarget as HTMLDetailsElement).open; setAbierto(a); guardarTecnicoAbierto(a); }}
      className="group rounded-2xl border border-slate-200 bg-slate-50/60">
      <summary className="flex cursor-pointer list-none items-center gap-3 px-5 py-4 [&::-webkit-details-marker]:hidden">
        <ChevronRight size={16} className="text-slate-400 transition-transform group-open:rotate-90" aria-hidden="true" />
        <Wrench size={15} className="text-slate-400" aria-hidden="true" />
        <span className="min-w-0">
          <span className="block text-sm font-semibold text-slate-800">Detalle técnico</span>
          <span className="block text-xs text-slate-500">{subtitulo}</span>
        </span>
        {conFalla && <span className="ml-auto rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-800">Falló la última actualización</span>}
      </summary>
      <div className="space-y-6 border-t border-slate-200 px-5 py-5">{children}</div>
    </details>
  );
}

export default DetalleTecnico;
